var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u05D0\u05D9\u05E7\u05D5\u05DF \u05DC\u05E4\u05D5\u05E4\u05D0\u05E4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05D0\\u05D9\\u05E7\\u05D5\\u05DF-\\u05DC\\u05E4\\u05D5\\u05E4\\u05D0\\u05E4",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4.00835073 4 48 4 48 0 0 0 0 48 4.00835073 48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "59.9916493 16 59.9916493 60 16 60 16 64 64 64 64 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "26.0220994 47.9226519 30 47.9226519 30 34 16.0773481 34 16.0773481 37.9779006 23.2097238 37.9779006 12 49.1876243 14.8123757 52 26.0220994 40.7902762"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(9.074708, 54.930577) rotate(-135.000000) translate(-9.074708, -54.930577) ",
    points: "7.07472718 52.9305962 11.0746888 52.9305962 11.0746888 56.9305578 7.07472718 56.9305578"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(3.410420, 60.583135) rotate(-135.000000) translate(-3.410420, -60.583135) ",
    points: "1.41043949 58.5831537 5.41040113 58.5831537 5.41040113 62.5831154 1.41043949 62.5831154"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "37.9779006 16.0773481 34 16.0773481 34 30 47.9226519 30 47.9226519 26.0220994 40.7902762 26.0220994 52 14.8123757 49.1876243 12 37.9779006 23.2097238"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(54.928812, 9.069392) rotate(45.000000) translate(-54.928812, -9.069392) ",
    points: "52.9288315 7.06941119 56.9287931 7.06941119 56.9287931 11.0693728 52.9288315 11.0693728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(60.582299, 3.416951) rotate(45.000000) translate(-60.582299, -3.416951) ",
    points: "58.5823183 1.41697007 62.58228 1.41697007 62.58228 5.41693171 58.5823183 5.41693171"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColide);
export default __webpack_public_path__ + "static/media/colide.1d6b506055e0f37457385cbba9e9b1e8.svg";
export { ForwardRef as ReactComponent };